import { useObservableState } from 'observable-hooks';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';

import Form from '../../../../components/form';
import Checkbox from '../../../../components/form/elements/checkbox';
import Date from '../../../../components/form/elements/date';
import Group from '../../../../components/form/elements/group';
import Link from '../../../../components/form/elements/link';
import Readonly from '../../../../components/form/elements/readonly';
import Text from '../../../../components/form/elements/text';
import Employee from '../../../../interfaces/employee';
import {
  HUMAN_EMPLOYEES_EDIT,
  HUMAN_EMPLOYEES_INDEX,
} from '../../../../router/routes';
import { useService } from '../../../../services/services';
import { can, route } from '../../../../services/utils';
import { RootState } from '../../../../store/store';

const schema = yup.object().shape({
  last_name: yup.string().max(255).required(),
  first_name: yup.string().max(255).required(),
  position: yup.string().max(255).required(),
});

export default function ViewEmployee() {
  const { employeeService } = useService();
  const [body, setBody] = useState([]);
  const [footer, setFooter] = useState([]);
  const { farmId, id } = useParams<{ farmId: string; id: string }>();

  const { farmUser } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
  }));

  const [employee] = useObservableState<Employee>(
    () => employeeService.show(farmId, id),
    null
  );

  useEffect(() => {
    if (employee === null) {
      return;
    }
    setBody([
      Readonly([
        Group([
          Text('last_name'),
          Text('first_name'),
          Text('position'),
          Text('phone', 'contact_phone'),
          Date('hired_at'),
          Date('fired_at'),
          Checkbox('active'),
        ]),
      ]),
    ]);

    setFooter(() => {
      let elements = [];

      if (can(farmUser, { title: 'update employee' })) {
        elements.push(
          Link(route(HUMAN_EMPLOYEES_EDIT, { farmId, id: employee.id }), 'edit')
        );
      }
      return elements;
    });
  }, [farmUser, employee, setBody, setFooter, farmId]);

  return (
    <Form
      title={employee && employee.last_name.concat(' ', employee.first_name)}
      backTo={route(HUMAN_EMPLOYEES_INDEX, { farmId })}
      mode="view"
      noticeAccessor="ViewForm"
      body={body}
      footer={footer}
      values={employee}
      schema={schema}
    />
  );
}
